<template>
  <section
    id="cover"
    class="te-bg-datascience-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faChartPie"
        class="fa-fw mr-3 mt-2 hidden h-9 w-11 md:inline-block"
      />
      データサイエンス
      <br class="md:hidden">コース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      Pythonを使ってデータ分析の手法を習得
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        データサイエンスを勉強・学習できる講座。スクールで
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >は、統計学の基礎やPythonで実際に分析する方法まで習得することができます。データサイエンティストとして活躍したい方におすすめ。通過率10%を突破した現役エンジニアから学べるオンラインのプログラミングスクール。1人では続かない方のためのパーソナルメンターがつくプログラミングブートキャンプ。専属のパーソナルメンターがマンツーマンでサポート。転職サポートもあり。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>

    <!-- 経済産業省認定バッジ -->
    <TeCommonBadgeReskilling />
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import TeCommonBadgeReskilling from '~/components/Te/TeCommon/Badge/Reskilling/TeCommonBadgeReskilling.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChartPie } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  beginsAt: Date
  closesAt: Date
}

const options = {
  async setup() {
    return {
      faChartPie,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    TeCommonBadgeReskilling,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-datascience-image {
  height: 560px;
  background-image: linear-gradient(
      to top,
      rgba(5, 76, 66, 0.75),
      rgba(12, 171, 149, 0.75)
    ),
    url('~/assets/images/Te/TeCourse/Datascience/Cover/datascience.jpg');
  @media (min-width: 576px) {
    height: 600px;
  }
  @media (min-width: 768px) {
    height: 500px;
  }
}
</style>
